import { useTranslation } from 'react-i18next';
import { InfiosButton, InfiosIcon } from '@infios/uikit/react';
import type { OrderInsightPayload } from '../../interfaces/chat';
import { useReferenceAction } from '../../context/ReferenceActionContext';
import styles from './OrderInsightFooterActions.module.css';

interface OrderInsightFooterActionsProps {
  actions: OrderInsightPayload['actions'];
}

/**
 * Footer action row for `actions.escalateToCsr` / `actions.notifyCustomer`.
 * Both fields are optional — only what the backend actually populated is
 * rendered; the UI never invents a fallback action.
 */
export function OrderInsightFooterActions({ actions }: OrderInsightFooterActionsProps) {
  const { t } = useTranslation();
  const onReference = useReferenceAction();

  if (!actions.escalateToCsr && !actions.notifyCustomer) return null;

  return (
    <div className={styles.row} data-testid="footer-actions">
      {actions.escalateToCsr ? (
        <InfiosButton
          variant="secondary"
          size="compact"
          className={`${styles.btn} ${styles.escalate}`}
          onClick={() => onReference?.(actions.escalateToCsr!.reference)}
        >
          <InfiosIcon slot="prefix" name="account" />
          {actions.escalateToCsr.label || t('ChatbotUI.OrderInsight.EscalateToCsr')}
        </InfiosButton>
      ) : null}
      {actions.notifyCustomer ? (
        <InfiosButton
          variant="secondary"
          size="compact"
          className={styles.btn}
          onClick={() => onReference?.(actions.notifyCustomer!.reference)}
        >
          <InfiosIcon slot="prefix" name="send" />
          {actions.notifyCustomer.label || t('ChatbotUI.OrderInsight.NotifyCustomer')}
        </InfiosButton>
      ) : null}
    </div>
  );
}
